module.exports = __webpack_public_path__ + "media/images/main_events/2024/icon-chevron-d2aa7739bd3b7b9cde283bf2b958ac51.svg";